import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import {gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import '../../css/Content.css'

export const VideoJS = (props) => {
    const videoRef = React.useRef(null);
    const playerRef = React.useRef(null);
    const videoJSPlayer = React.useRef(null)
    const {options, onReady} = props;
    const [isMobile, setIsMobile] = React.useState(false)
    const [progress, setProgress] = React.useState(0)
    gsap.registerPlugin(ScrollTrigger)

    React.useEffect(() => {
        props.getVideo && props.getVideo(videoRef.current)
        if (window.innerWidth < 600) {
            const videos = document.querySelectorAll('video')
             for (let i=0; i<videos.length; i++) {
                videos[i].pause()
             }
        }
        let intervalID = setInterval(() => {
            if (progress === 100) {
                clearInterval(intervalID);
            } else if (videoRef.current === null) {
                return
            } else {
                if (isNaN(videoRef.current.duration))   // duration is NotaNumber at Beginning.
                    return;
                setProgress((videoRef.current.currentTime / videoRef.current.duration) * 100)
            }
        }, 50);
    }, [])

    React.useEffect(() => {
        if (window.innerWidth < 600 && props.page !== 'content' && props.page !== 'content_creator' && props.page !== 'influencer_banner') {
            setIsMobile(true)
            ScrollTrigger.create({
                trigger: videoRef.current,
                start: 'top center',
                end: 'top 120px',
                onEnter: () => {
                    if (props.page ==='influencer_swiper') {
                        const swiperActive = document.querySelectorAll('.swiper-slide-active')
                        //Plays video if it's in the active zone and is the active slide
                        for (let i=0; i<swiperActive.length; i++) {
                            if (swiperActive[i].querySelector('video') === videoRef.current) {
                                setTimeout(() => {
                                    if (videoRef.current && videoJSPlayer.current)
                                    {
                                        const videos = document.querySelectorAll('video')
                                        for (let i=0; i<videos.length; i++) {
                                            videos[i].pause()
                                        }
                                        videoRef.current.play()
                                        videoJSPlayer.current.previousElementSibling.classList.add('hidden')
                                    }
                                }, 800)
                            }
                        }
                    }
                    else {
                        setTimeout(() => {
                            if (videoRef.current && videoJSPlayer.current)
                            {
                                const videos = document.querySelectorAll('video')
                                for (let i=0; i<videos.length; i++) {
                                    videos[i].pause()
                                }
                                videoRef.current.play()
                                videoJSPlayer.current.previousElementSibling.classList.add('hidden')
                            }
                        }, 800)
                    }
                    
                },
                onEnterBack: () => {
                    if (props.page ==='influencer_swiper') {
                        const swiperActive = document.querySelectorAll('.swiper-slide-active')
                        //Plays video if it's in the active zone and is the active slide
                        for (let i=0; i<swiperActive.length; i++) {
                            if (swiperActive[i].querySelector('video') === videoRef.current) {
                                setTimeout(() => {
                                    if (videoRef.current && videoJSPlayer.current)
                                    {
                                        const videos = document.querySelectorAll('video')
                                        for (let i=0; i<videos.length; i++) {
                                            videos[i].pause()
                                        }
                                        videoRef.current.play()
                                        videoJSPlayer.current.previousElementSibling.classList.add('hidden')
                                    }
                                }, 800)
                            }
                        }
                    }
                    else {
                        setTimeout(() => {
                            if (videoRef.current && videoJSPlayer.current)
                            {
                                const videos = document.querySelectorAll('video')
                                for (let i=0; i<videos.length; i++) {
                                    videos[i].pause()
                                }
                                videoRef.current.play()
                                videoJSPlayer.current.previousElementSibling.classList.add('hidden')
                            }
                        }, 800)
                    }
                },
                onLeave: () => {
                    if (videoRef.current && videoJSPlayer.current)
                        {
                            videoRef.current.pause()
                            videoJSPlayer.current.previousElementSibling.classList.remove('hidden')
                        }
                },
                onLeaveBack: () => {
                    if (videoRef.current && videoJSPlayer.current)
                        {
                            videoRef.current.pause()
                            videoJSPlayer.current.previousElementSibling.classList.remove('hidden')
                        }
                },
                markers: false
            })

        }
        // Content page
        else if (window.innerWidth < 600 && props.page === 'content') {
        }
    },[isMobile])

    React.useEffect(() => {
        // Make sure Video.js player is only initialized once
        if (!playerRef.current) {
            const videoElement = videoRef.current;

            if (!videoElement) return;

            const player = playerRef.current = videojs(videoElement, options, () => {
                videojs.log('player is ready');
                onReady && onReady(player);
                // play the video 
                if (props.page === 'content_creator'){
                    videoElement.play();
                }
                // add event listener to pause all videos and audio on play
            });

        // You could update an existing player in the `else` block here
        // on prop change, for example:
        } else {
            const player = playerRef.current;
            player.fluid(options.fluid)
            player.fill(options.fill)
        }
    }, [options, videoRef]);

    // Dispose the Video.js player when the functional component unmounts
    React.useEffect(() => {
        const player = playerRef.current;

        return () => {
            if (player) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    var medias = Array.prototype.slice.apply(document.querySelectorAll('audio,video'));
    medias.forEach(function(media) {
      media.removeEventListener('play', {})
      media.addEventListener('play', function(event) {
        medias.forEach(function(media) {
          if(event.target != media){
            media.pause();
          } else {
            media.play();
          }
        });
      });
    });

    return (
        <div data-vjs-player className='video_js_container' ref={videoJSPlayer} onContextMenu={e => e.preventDefault()} style={{transform:'scaleX(1)', position:'relative'}}>
            {props.contentType === 'ivs' && props.live_camera_style === 'portrait' &&
            <>
                <div className='video-cutoff-div' style={{
                height: '100%',
                width: 'calc(100% * 37/128)',
                backgroundColor: 'white',
                zIndex: '2',
                position: 'absolute',
                left:'0',
                top:'0'
                }}></div>
                <div className='video-cutoff-div' style={{
                height: '100%',
                width: 'calc(100% * 37/128)',
                backgroundColor: 'white',
                zIndex: '2',
                position: 'absolute',
                right: '0',
                top:'0'
                }}
                ></div>
            </>
            }
            {props.page === 'content_edit' ?
            <video crossOrigin='anonymous' playsInline onContextMenu={e => e.preventDefault()} onLoad={(videoRef) => props.getVideo && props.getVideo(videoRef.target)}
            ref={videoRef} preload="metadata" className='video-js vjs-big-play-centered' 
                    onLoadedMetadata={(videoRef) => {
                        // If getContentDuration is passed as a function, call the function
                        props.getContentDuration && props.getContentDuration(videoRef.target)
                    }}/> : 
            props.page === 'content_creator' ? 
                <video 
                    // crossOrigin='anonymous' 
                    style={
                        {
                            position: 'relative', 
                            height: '100%', 
                            width: '100%', 
                            borderRadiusBottomLeft: '0px', 
                            borderRadiusBottomRight: '0px',
                        }
                    } 
                    playsInline 
                    onContextMenu={e => e.preventDefault()} 
                    onLoad={(videoRef) => props.getVideo && props.getVideo(videoRef.target)}
                    ref={videoRef} 
                    preload="metadata"
                    className='video-js vjs-big-play-centered' 
                    onLoadedMetadata={
                        (videoRef) => {
                            // If getContentDuration is passed as a function, call the function
                            props.getContentDuration && props.getContentDuration(videoRef.target)
                        }}
                    />:
                    <video playsInline onContextMenu={e => e.preventDefault()} onLoad={(videoRef) => props.getVideo && props.getVideo(videoRef.target)}
                    ref={videoRef} preload="metadata" className='video-js vjs-big-play-centered' 
                    onLoadedMetadata={(videoRef) => {
                        videoRef.target.autoplay = false
                        // If getContentDuration is passed as a function, call the function
                        props.getContentDuration && props.getContentDuration(videoRef.target)
                        if (props.contentType === 'ivs' && !props.isStreaming && !isNaN(videoRef.target.duration)) {
                            props.setLiveDuration(videoRef.target.duration)
                        }
                    }}
                    // flip live previews
                    style={
                        props.contentType === 'ivs' && 
                        props.page !== 'content_main' && 
                        props.page !== 'influencer_banner' &&
                        props.page !== 'content_edit' ? {transform:'scaleX(-1)'} : {}

                    }/>
                }
                    
            {/* Removes duplicate progress bar for main content video  */}
            {(props.page !== 'content_main' && props.page !== 'influencer_banner') && props.page !== 'content_edit' && 
            <progress id='preview_progress_bar' max='100' value={progress}  style={{
                position: 'absolute',
                width:'100%',
                bottom:'0',
                height:'6px',
                appearance:'none',
                WebkitAppearance:'none',
                MozAppearance:'none',
                zIndex: '3',
            }}/>}
        </div>
    );
}

export default VideoJS;